import React, { useEffect } from "react";
import {
  companyProfilePicImage,
  emailIconImaage,
  phoneIconImage,
  photoUserImage,
} from "../../assets";
import { useState } from "react";
import { Avatar, formatMs } from "@material-ui/core";
import { invokeApi, s3baseUrl } from "../../bl_libs/invokeApi";
import { Alert } from "@material-ui/lab";
import { validatePasswordStrength } from "../../ui_libs/Validations/validations";
import TotalHours from "./components/Total-Hours/TotalHours";
import { withRouter } from "react-router-dom";
function ForemanProfile(props) {
  // use profile data from localStorage

  const { profile_pic, first_name, last_name, email, phone } = JSON.parse(
    localStorage.getItem("user")
  );

  //handle erros messages
  const [errMessage, setErrMessage] = React.useState("");

  ///////////////////////////////////////////////////////////////update password section

  const [updatePassword, setUpdatePassword] = useState({
    password: "",
    confirm_password: "",
  });

  const [updatePasswordSuccessMessage, setUpdatePasswordSuccessMessage] =
    useState("");

  const [passStrength, setPassStrength] = React.useState({
    color: "",
    strength: "",
    level: 0,
  });

  const handleUpdatePasswordInputs = (e) => {
    if (e.target.id === "password") {
      setPassStrength(validatePasswordStrength(e.target.value));
    }
    setUpdatePassword({
      ...updatePassword,
      [e.target.id]: e.target.value.trim(),
    });
  };

  const handleUpdatePasswordSubmit = (e) => {
    e.preventDefault();

    //validations step for password
    if (updatePassword.password.length < 8) {
      setErrMessage("Minimum 8 characters required for password");
      return;
    }
    //
    //check password strength
    if (passStrength.level < 3) {
      setErrMessage(
        "A minimum 8 characters password contains a combination of uppercase, number. And at least one special character are required."
      );
      return;
    }
    //match password
    if (updatePassword.password !== updatePassword.confirm_password) {
      setErrMessage("Your password and confirmation password does not match");
      return;
    }

    //Api call
    let requestObj = {
      path: "/app_api/update_password",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = updatePassword;
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setErrMessage("");
        setUpdatePasswordSuccessMessage("Password updated successfully");
        setTimeout(() => {
          document.getElementById("close-change-password").click();
          setTimeout(() => {
            setUpdatePasswordSuccessMessage("");
          }, 500);
        }, 1000);
      } else {
        setErrMessage(res.message);
      }
    });
  };

  ///////////////////////////////////////////////////////////////////////////////////
  return (
    <>
      <section id="content-wrapper" className="content-wrapper profile-page">
        <div className="container-fluid">
          <p className="small-text-bold">Foreman Information</p>
          <div className="company-profile-wrapper">
            <div className="change-pwd-wrapper">
              <span
                className="border-0 bg-transparent red-color caption pointer-point"
                data-toggle="modal"
                data-target="#change-password"
                onClick={() => {
                  setErrMessage("");
                  setUpdatePasswordSuccessMessage("");
                  setUpdatePassword({
                    password: "",
                    confirm_password: "",
                  });
                }}
              >
                Change password
              </span>
            </div>
            <div className="row pt-3 pt-sm-0 pb-sm-0 pb-3">
              <div className="col-4 col-sm-3 col-md-2 col-lg-2 pr-0 text-right">
                {profile_pic ? (
                  //if profile picture is available show profile
                  <img
                    style={{ width: 120, height: 120 }}
                    src={s3baseUrl + profile_pic}
                    className="circle-box rounded-circle full-width-height"
                  />
                ) : (
                  //else show default picture
                  <Avatar
                    style={{
                      width: 110,
                      height: 110,
                      fontSize: 22,
                      float: "right",
                    }}
                  ></Avatar>
                )}
              </div>
              <div className="col-8 col-sm-9 col-md-10 col-lg-10 half-grid-padding-left pt-4 pt-lg-40">
                <h5>{first_name + " " + last_name}</h5>
                <div className="row address-licence-wrapper desktop-visible">
                  <div className="col-12">
                    <div className="row mt-20">
                      <div className="col-2 col-sm-1">
                        <img src={emailIconImaage} />
                      </div>
                      <div className="col-10 col-sm-11 small-font-size pl-0">
                        {email}
                      </div>
                    </div>
                    <div className="row mt-20">
                      <div className="col-2 col-sm-1">
                        <img src={phoneIconImage} />
                      </div>
                      <div className="col-10 col-sm-10 small-font-size pl-0">
                        {phone}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12">
                        <button
                          className="red-btn custom-btn-small mt-20"
                          onClick={() =>
                            props.history.push("/foreman/edit-profile")
                          }
                        >
                          Edit Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="address-licence-wrapper-2 mobile-visible">
            <div className="row justify-content-end">
              <div className="col-12 col-sm-11 half-grid-padding-left">
                <div className="row address-licence-wrapper mobile-visible">
                  <div className="col-12">
                    <div className="row mt-20">
                      <div className="col-2 col-sm-1">
                        <img src={emailIconImaage} />
                      </div>
                      <div className="col-10 col-sm-11 small-font-size pl-0">
                        {email}
                      </div>
                    </div>
                    <div className="row mt-20">
                      <div className="col-2 col-sm-1">
                        <img src={phoneIconImage} />
                      </div>
                      <div className="col-10 col-sm-10 small-font-size pl-0">
                        {phone}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12">
                        <button
                          className="red-btn custom-btn-small mt-20"
                          onClick={() =>
                            props.history.push("/foreman/edit-profile")
                          }
                        >
                          Edit Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* // */}
          <TotalHours />
        </div>
      </section>

      {/* // <!-- Change Password --> */}
      <div
        className="modal fade"
        id="change-password"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="change-password-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-change-password"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {updatePasswordSuccessMessage !== "" ? (
              <Alert variant="filled" severity="success">
                {updatePasswordSuccessMessage}
              </Alert>
            ) : (
              <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
                <div className="modal-body p-0">
                  <h5 className="text-center" id="change-password-title">
                    Change password
                  </h5>
                  {errMessage && (
                    <Alert variant="filled" severity="error">
                      {errMessage}
                    </Alert>
                  )}

                  <div className="form-box pt-20">
                    <form onSubmit={handleUpdatePasswordSubmit}>
                      <div className="form-group">
                        <label
                          htmlFor="password"
                          className="overline dark-grey-color"
                        >
                          New Password
                        </label>
                        <input
                          required
                          type="password"
                          className="form-control small-font-size"
                          id="password"
                          value={updatePassword.password}
                          onChange={handleUpdatePasswordInputs}
                          placeholder="*****************"
                        />
                        {passStrength.level > 0 && updatePassword.password && (
                          <div
                            className="progress"
                            style={{ height: 2, marginTop: -3 }}
                          >
                            <div
                              className={
                                "progress-bar " +
                                ((passStrength.level < 2 && "bg-danger") ||
                                  // (passStrength.level === 2 && "bg-info") ||
                                  (passStrength.level === 3 &&
                                    updatePassword.password.length >= 8 &&
                                    "bg-success"))
                              }
                              role="progressbar"
                              style={{
                                width: passStrength.level * 33.333 + "%",
                              }}
                              aria-valuenow={passStrength.level}
                              aria-valuemin="0"
                              aria-valuemax="3"
                            ></div>
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="confirm_password"
                          className="overline dark-grey-color"
                        >
                          Re-Enter New Password
                        </label>
                        <input
                          required
                          type="password"
                          className="form-control small-font-size"
                          id="confirm_password"
                          value={updatePassword.confirm_password}
                          onChange={handleUpdatePasswordInputs}
                          placeholder="*****************"
                        />
                      </div>
                      <div className="form-group pt-3">
                        <button
                          type="submit"
                          className="red-btn custom-buton custom-buton-large w-100"
                        >
                          Save Password
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(ForemanProfile);
